// src/components/dashboard/DiscoveryFunnelChart.tsx
import React from 'react';
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent, type ChartConfig } from '../ui/chart';

// Single accent color, not the 5-token chart-* palette — up to 12
// categories (INTENT_MAP labels from ai_traffic), too many for 5
// grayscale tokens to differentiate meaningfully. Bar length already
// carries the information; color here is brand consistency.
const chartConfig = {
  count: { label: 'Events', color: 'var(--color-brand-accent)' },
} satisfies ChartConfig;

interface DiscoveryFunnelChartProps {
  byFunction: Record<string, number>;
}

export const DiscoveryFunnelChart: React.FC<DiscoveryFunnelChartProps> = ({ byFunction }) => {
  const chartData = Object.entries(byFunction)
    .map(([name, count]) => ({ name, count }))
    .sort((a, b) => b.count - a.count);

  if (chartData.length === 0) {
    return <p className="text-sm text-brand-gray font-mono">No agent activity yet.</p>;
  }

  return (
    <ChartContainer config={chartConfig} className="min-h-[400px] w-full">
      <BarChart accessibilityLayer data={chartData} layout="vertical" margin={{ left: 20 }}>
        <CartesianGrid horizontal={false} />
        <XAxis type="number" hide />
        <YAxis
          type="category"
          dataKey="name"
          tickLine={false}
          axisLine={false}
          tickMargin={8}
          width={140}
          fontSize={12}
        />
        <ChartTooltip content={<ChartTooltipContent />} />
        <Bar dataKey="count" fill="var(--color-count)" radius={4} />
      </BarChart>
    </ChartContainer>
  );
};